import styles from '../PayNumberModal/PayNumber.module.css';

import { useModal } from '../../hooks/modalContext';
import clsx from 'clsx';
import { useAuth } from '../../../auth/Auth';
import { handleModalNavigation } from '../../utils/login';
import { getBuildingDetails } from '../../../auth/_requests';

const IncompleteIdentity = () => {
  const { setModal, modalState } = useModal();
  const progressData = modalState?.profileProgressData;
  const { auth } = useAuth();

  const checkProgress = async () => {
    const buildingData = await getBuildingDetails(auth?.data?.token || '');
    handleModalNavigation(
      progressData ?? null,
      buildingData ? buildingData.data[0].building?.tenantBuildingId : '',
      setModal,
      auth?.data.token || ''
    );
  };

  return (
    <main className={clsx(styles.main)}>
      <section className={styles.section}>
        <h2 className='text-main text-[20px]'>Verify your identity</h2>
        <p className='text-light/70 text-center mb-5 mt-5'>
          You have not completed your identity verification. Please finish this step to secure your
          account and start making payments.
        </p>
        <div className={styles.buttonFlex}>
          <button className='submitBtn' onClick={checkProgress}>
            Verify now
          </button>
          <button
            className='cancelBtn'
            onClick={() => {
              setModal(null);
            }}
          >
            Close
          </button>
        </div>
      </section>
    </main>
  );
};
export default IncompleteIdentity;
